// extracted by mini-css-extract-plugin
export var author = "cJ_hw";
export var container = "cJ_c";
export var separator = "cJ_hx";